const IS_SCROLL_TO_TOP = 'IS_SCROLL_TO_TOP';

export function takeOverScrollToTop(payload) {
  return {
    type: IS_SCROLL_TO_TOP,
    payload,
  };
}

const intialGlobalInfo = {
  takeOverscroll: false,
};

export default function isTakeOverscroll(state = intialGlobalInfo, action) {
  const { type, payload } = action;

  switch (type) {
    case IS_SCROLL_TO_TOP:
      return Object.assign({}, state, { takeOverscroll: payload?.takeOverscroll ?? !state.takeOverscroll });
    default:
      return state;
  }
}
